/**
 * Typing indicator -- three animated dots shown while waiting for the
 * first token from the AI response stream.
 */

export function TypingIndicator(): React.ReactElement {
  return (
    <div className="flex items-center gap-1 px-4 py-3">
      <div className="flex gap-1">
        <span className="w-2 h-2 rounded-full bg-text-tertiary animate-bounce [animation-delay:0ms]" />
        <span className="w-2 h-2 rounded-full bg-text-tertiary animate-bounce [animation-delay:150ms]" />
        <span className="w-2 h-2 rounded-full bg-text-tertiary animate-bounce [animation-delay:300ms]" />
      </div>
      <span className="text-xs text-text-tertiary ml-2">
        Atlas is thinking...
      </span>
    </div>
  );
}
